import { filesTypes } from "@fl/shared/src/types/models/suporte_fl/arquivos";
import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiArquivos extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "files";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  download = async (type: filesTypes, id: number) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/download/${type}/${id}`;
    this.config.method = "get";
    this.config.responseType = "arraybuffer";

    this.result = await axios(this.config)
      .then(async (response) => {
        return { success: true, message: undefined, data: response.data };
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Exportação de Relatório",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };
}

export default ApiArquivos;
